import { render, staticRenderFns } from "./DeleteAdminButton.vue?vue&type=template&id=3977e507&"
import script from "./DeleteAdminButton.vue?vue&type=script&lang=js&"
export * from "./DeleteAdminButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports